export default __webpack_public_path__ + "static/media/img-intro-banner-token@3x.3e8d944f.png";